/**
 * Remove :focus outline unless user is using the keyboard to navigate
 *
* @version     1.0.0
 */
export function handleFirstTab(e) {
	if (e.key === 'Tab') {
		document.body.classList.add('u-user-is-tabbing')
		window.removeEventListener('keydown', handleFirstTab)
		window.addEventListener('mousedown', handleMouseDownOnce)
	}
}

function handleMouseDownOnce() {
	document.body.classList.remove('u-user-is-tabbing')
	window.removeEventListener('mousedown', handleMouseDownOnce)
	window.addEventListener('keydown', handleFirstTab)
}

/**
 * Fix full-bleed overflow with visible scrollbars
 *
* @version     1.0.0
 */
export function scrollbarFix() {
	const hasScrollbar = window.innerWidth > document.documentElement.clientWidth

	if (hasScrollbar) {
		const scrollbarWidth =
			window.innerWidth - document.documentElement.clientWidth
		const fullBleedEls = document.querySelectorAll('.u-full-bleed')

		fullBleedEls.forEach((el) => {
			el.style.setProperty(
				'--full-bleed-width',
				`calc(100vw - ${scrollbarWidth}px)`
			)
			el.style.setProperty(
				'--full-bleed-margin',
				`calc(50% - 50vw + ${scrollbarWidth / 2}px)`
			)
		})
	}
}

/**
 * Disable animations on resize
 *
 * @author      Andy Bell
 * @version     1.0.0
 * @see         https://css-tricks.com/stop-animations-during-window-resizing/
 */

let resizeTimer
export function disableAnimationOnResize() {
	document.body.classList.add('u-resize-animation-stopper')
	clearTimeout(resizeTimer)
	resizeTimer = setTimeout(() => {
		document.body.classList.remove('u-resize-animation-stopper')
	}, 400)
}

export function capitalizeString(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Collapse section with height animation
 *
 * @author      Brandon Smith
 * @version     1.0.0
 * @see         https://codepen.io/brundolf/pen/dvoGyw
 */
export function collapseSection(
	element,
	expandedSibling = false,
	collapsedHeight = 0
) {
	// Get the height of the element's inner content, regardless of its actual size
	const sectionHeight = element.scrollHeight

	// Temporarily disable all css transitions
	const elementTransition = element.style.transition
	element.style.transition = ''

	// On the next frame (as soon as the previous style change has taken effect),
	// explicitly set the element's height to its current pixel height, so we
	// aren't transitioning out of 'auto'
	requestAnimationFrame(function () {
		element.style.height = `${sectionHeight}px`
		element.style.transition = elementTransition

		// On the next frame (as soon as the previous style change has taken effect),
		// have the element transition to height: 0
		requestAnimationFrame(function () {
			element.style.height = `${collapsedHeight}px`
		})
	})

	// Mark the section as "currently collapsed"
	element.setAttribute('data-collapsed', 'true')

	// If is a second level menu item collapse the parent submenu (because of avoerflow:hidden)
	const elementParent = element.parentNode.parentNode
	if (elementParent.classList.contains('sub-menu') && !expandedSibling) {
		elementParent.style.height = `${
			elementParent.offsetHeight - sectionHeight
		}px`
	}
}

/**
 * Expand section with height animation
 *
 * @author      Brandon Smith
 * @version     1.0.0
 * @see         https://codepen.io/brundolf/pen/dvoGyw
 */
export function expandSection(element, expandedSibling = false) {
	// Get the height of the element's inner content, regardless of its actual size
	const sectionHeight = element.scrollHeight

	// Have the element transition to the height of its inner content
	element.style.height = `${sectionHeight}px`

	// Mark the section as "currently not collapsed"
	element.setAttribute('data-collapsed', 'false')

	// If is a second level menu item expand the parent submenu (because of avoerflow:hidden)
	const elementParent = element.parentNode.parentNode
	if (elementParent.classList.contains('sub-menu')) {
		// If there are siblings open calc the height diff
		if (expandedSibling) {
			const heightDiff =
				sectionHeight - expandedSibling.nextElementSibling.scrollHeight
			elementParent.style.height = `${
				elementParent.offsetHeight + heightDiff
			}px`
			// If nothing is open just use the submenu heigh
		} else {
			elementParent.style.height = `${
				elementParent.offsetHeight + sectionHeight
			}px`
		}
	}
}
